import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";
import {BenjiKIVSymbol} from "../../reels/BenjiKIVSymbol";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {gsap} from "gsap";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIBetType} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetType";
import {BenjiKIVXBetView} from "../../view/general/BenjiKIVXBetView";
import {BenjiKIVSound} from "../../sound/BenjiKIVSound";

/**
 * Created by Jerker Nord on 2023-01-13.
 */

export class BenjiKIVNormalSpinRunner implements SimplePresentation {

    private _shouldStartSpin:boolean = false;
    private _gotBet:boolean = false;
    private _shouldAbortXbet:boolean = false;
    private _controller:SimplePresentationRunnerController;
    private _reInitRedXBetDelay:number;
    private _isPromoFeatureBet:boolean = false;

    constructor() {
        BenjiKIV.apiPlugin.events.on(APIEvent.BET, (data:APIBetEventData) => this.onBet(data));
    }

    public shouldRun():boolean {
        this._gotBet = false
        if(this._isPromoFeatureBet == true) {
            this._isPromoFeatureBet = false;
            this._gotBet = true;
        }
        this._reInitRedXBetDelay = 0;
        this.checkToInitRedXBet();
        return true;
    }

    private checkToInitRedXBet():void {
        if(BenjiKIV.xBetView.boosted02Enabled == true && (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN)) {
            this._reInitRedXBetDelay = 0.6;
            //let activateBoost2TL:gsap.core.Timeline = gsap.timeline();
            //activateBoost2TL.add(BenjiKIV.overlayScatterView.getHideAllOverlays());
            //activateBoost2TL.add(() => BenjiKIV.overlayScatterView.activateBoostedOverlays(), "+=0.6");
            BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier(true);
        }
    }

    //Turn off boosted bet on feature buy
    private onBet(data:APIBetEventData):void {
        if(data.data && data.data.isPromotional && data.data.isPromotional == true) {
            //Promo feature bet.
            this._isPromoFeatureBet = true;
        }
        if((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)) {
            if(data.playerInteraction) {
                if(data.type == APIBetType.FEATURE_BET && (data.playerInteraction.featureName !== BenjiKIVXBetView.BOOST_BET_1
                    && data.playerInteraction.featureName !== BenjiKIVXBetView.BOOST_BET_2)) {
                    if(BenjiKIV.xBetView.boosted01Enabled == true || BenjiKIV.xBetView.boosted02Enabled == true) {
                        this._shouldAbortXbet = true;
                    }
                }
            }
            this._gotBet = true;
            this.checkToStart();
        }
    }

    public start(controller:SimplePresentationRunnerController):void {
        this._controller = controller;
        this._shouldStartSpin = true;
        this.checkToStart();
    }

    private checkToStart():void {
        if(this._gotBet == true && this._shouldStartSpin == true) {
            if(this._shouldAbortXbet == true) {
                BenjiKIV.xBetView.enableButtons(false);
                BenjiKIV.xBetView.turnOffBoost(true);
                this._shouldAbortXbet = false;
                BenjiKIV.xBetView.isFeatureBuyAbort = true;
            }
            this._shouldStartSpin = false;
            this.reallyStart();
        }
    }

    private reallyStart():void {
        //Triggers overlay scatters for different modes. Needs to be done here so no new server reply has time to sneak in.
        BenjiKIV.respinOverlayRunner.run = false;
        BenjiKIV.freeSpinOverlayRunner.run = false;
        BenjiKIV.superFSOverlayRunner.run = false;
        BenjiKIV.normalBoostedOverlayRunner.run = false;

        if(BenjiKIV.xBetView.boosted02Enabled == true) {
            //Normal + extra
            //extra + normal
            //fs + normal
            //sfs + normal
            if(BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL || BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL) {
                BenjiKIV.normalBoostedOverlayRunner.run = true;
            }
        }

        if(BenjiKIV.normalBoostedOverlayRunner.run == false) {
            if(BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN) {
                BenjiKIV.respinOverlayRunner.run = true;
            }
        }

        //Hide intro (if active)
        BenjiKIV.introView.hideIntro();

        //Remove dark overlay on all syms
        for(let i:number = 0; i < BenjiKIV.allReelView.reelModels.length; i++) {
            for(let j:number = 0; j < BenjiKIV.allReelView.reelModels[i].reelView.symbols.length; j++) {
                (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[i].reelView.symbols[j]).darkOverlay.alpha = 0;
            }
        }

        const tl:gsap.core.Timeline = gsap.timeline({
            delay : this._reInitRedXBetDelay,
            onComplete : () => this._controller.finish()
        });

        tl.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.REELS_SPINNING, 1, 10000)});

        tl.add(() => {
            if(BenjiKIV.xBetView.boosted02Enabled == true && BenjiKIV.overlayScatterView.activeOverlayScatters.length == 0) {
                if(BenjiKIV.model.betWayWins && BenjiKIV.model.betWayWins.length > 0) {
                    BenjiKIV.overlayScatterView.activateBoostedOverlays();
                    tl.add(gsap.timeline({delay : 1}));
                }
            }
        })

        //Reset enhancer view
        if(((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL))
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
        ) {
            if(BenjiKIV.xBetView.boosted02Enabled == false) {
                BenjiKIV.enhancerView.reset();
                tl.add(BenjiKIV.overlayScatterView.getHideAllOverlays());
            } else {
                //Red xBet is ON. New spin after Normal, FS or SFS.
                BenjiKIV.enhancerView.reset();
                tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            }
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next FS spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if((BenjiKIV.xBetView.boosted02Enabled == true && (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL))) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next boosted spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next FS spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN) {
            BenjiKIV.enhancerView.reset();
            //Small delay before next FS spin
            tl.add(gsap.timeline({delay : 0.4}));
        }

        const delay:number = BenjiKIVStatics.betweenReelsStartDelay;
        tl.add(BenjiKIV.allReelView.reelModels[0].start().restart(), 0);
        tl.add(BenjiKIV.allReelView.reelModels[1].start().restart(), delay);
        tl.add(BenjiKIV.allReelView.reelModels[2].start().restart(), delay * 2);
        tl.add(BenjiKIV.allReelView.reelModels[3].start().restart(), delay * 3);
        tl.add(BenjiKIV.allReelView.reelModels[4].start().restart(), delay * 4);
    }
}